/*
 * Copyright (c) 2019. 42 bv (www.42.nl). All rights reserved.
 */
"use strict";

/**
 * @ngdoc function
 * @name diceApp.component:diceBulkChangeButton
 */
angular.module("diceApp").component("diceBulkChangeButton", {
  bindings: {
    evaluationTypeId: "<",
    getEvaluations: "&"
  },
  templateUrl: "es6/evaluations/bulk/bulk.change.button.html",
  controllerAs: "bulkChangeButtonController",
  controller: function ($q, Bulk, EvaluationType) {
    const bulkChangeButtonController = this;

    bulkChangeButtonController.open = function () {
      $q.all([
        EvaluationType.get({
          id: bulkChangeButtonController.evaluationTypeId
        }).$promise,
        bulkChangeButtonController.getEvaluations()
      ]).then(([type, evaluations]) => {
        Bulk.showChangeModal(evaluations, type);
      });
    };
  }
});
